import { render, staticRenderFns } from "./enrollIndex.vue?vue&type=template&id=5f6ced2a&scoped=true"
import script from "./enrollIndex.vue?vue&type=script&lang=js"
export * from "./enrollIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6ced2a",
  null
  
)

export default component.exports